<template>
    <!-- the expansion isn't smooth. the margins and paddings increase the height and width and v-expand-transition doesn't  seem to recognize that. -->
    <v-card class="ml-12 pa-0 rounded-0" color="transparent" max-width="455" max-height="300" flat
        style="overflow: auto;">
        <v-list-item v-show="!replies.length" class="reply-color" style="text-align: center;">
            <v-list-item-subtitle class="black--text">
                <v-textarea type="text" v-model="reply" clear-icon="mdi-close-circle" background-color="black"
                    @click:append="addNewReply" @keyup.enter="addNewReply" color="grey" autofocus="true"
                    placeholder="Add a comment..." class="text-body-2" clearable rounded auto-grow dense hide-details
                    filled rows="1"></v-textarea>
            </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-for="reply in replies" :key="reply.id" class="pt-0 pr-2">
            <v-list-item-avatar size="26" style="align-self: start;">
                <v-img src="https://cdn.vuetifyjs.com/images/lists/1.jpg"></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="pt-0">
                <v-bottom-sheet width="1200px" v-model="sheet">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="pl-0 text-left" color="transparent" elevation="0" max-width="150" v-bind="attrs"
                            v-model="sheet" v-on="on" x-small>
                            <v-list-item-title
                                class="author reply-color text-subtitle-2">{{ reply.author }}</v-list-item-title>
                        </v-btn>
                    </template>
                    <profilePage />
                </v-bottom-sheet>
                <v-list-item-subtitle
                    class="text-caption wrap-text black--text font-weight-normal">{{ reply.replyText }}</v-list-item-subtitle>
                <v-card-subtitle class="text-caption font-weight-light pa-0">
                    {{ getReplyTime(reply.created) }}
                    <span>·</span>
                    6 Likes
                    <span>·</span>
                    {{ reply.response }}
                    <v-icon color="black" size="small" @click="showAtReplyTextArea">
                        Reply(s)
                    </v-icon>
                </v-card-subtitle>
            </v-list-item-content>
            <v-icon size="16" @click="reply.liked = !reply.liked" :color="reply.liked ? 'red' : 'white'">mdi-heart</v-icon>
            <v-icon size="16" @click="reply.bookmark = !reply.bookmark"
                :color="reply.bookmark ? 'yellow' : 'white'">mdi-clipboard-outline</v-icon>
        </v-list-item>
        <addReply v-if="showAtTextArea" />
    </v-card>
</template>
<script>
import profilePage from './profilePage'
import addReply from './addReply'
const moment = require('moment')
moment().format()
export default {
    data: () => ({
        showAtTextArea: false,
        showProfilePage: false,
        reply: "",
        replies: [],
    }),
    components: {
        profilePage,
        addReply,
    },
    methods: {
        toggleProfilePage() {
            this.showProfilePage = !this.showProfilePage;
        },
        addNewReply() {
            if (!this.reply) return;
            const newReply = {
                id: Date.now(),
                replyText: this.reply,
                liked: false,
                bookmark: false,
                dislike: false,
                created: Date.now(),
                author: "Marcus Garvey",
                response: '5',
            }
            this.replies = [...this.replies, newReply];
            this.reply = ""
        },
        getReplyTime(replyPublishedDate) {
            // Get todays date and the published date and find out how long
            // it's being since the article was posted.
            //
            //const m1 = new Date(); // prints: Toady's date
            const m2 = new Date(replyPublishedDate) // prints: Date of article
            const timeFromNow = moment(m2).fromNow() // Returns date that article was created
            return timeFromNow
        },
        showAtReplyTextArea() {
            this.showAtTextArea = !this.showAtTextArea;
        },
    },
}
</script>
// used css for custom scrollbar and a couple of classes.
<style scoped>
::-webkit-scrollbar {
    width: 10px;
    height: 12px;
}

::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #ccc;
}

::-webkit-scrollbar-thumb:hover {
    background: #999;
}

.wrap-text {
    white-space: normal;
}

/* To avoid the dots appering on the ending of the replies  */
.reply-color {
    color: #000 !important;
    font-family: sans-serif;
    font-size: 0.8rem;
    font-weight: 600;
}

.author {
    font-family: sans-serif;
    font-size: 1.1rem;
    font-weight: 900;
}
</style>